import React from 'react';
import '../../assets/css/datepicker.css';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import AgentsTree from './AgentsTree';

class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      agents: null,
      product: null,
      status: null,
      showFilters: false,
      groupAgent: false,
      groupProduct: false,
      groupStatus: false
    };
  }

  getFiltersData = evt => {
    evt.preventDefault();
    this.props.onFilter({
      startDate: this.state.startDate
        ? moment(this.state.startDate)
            .utc()
            .format('YYYY-MM-DD') + "T00:00:00.000Z"
        : null,
      endDate: this.state.endDate
        ? moment(this.state.endDate)
            .utc()
            .format('YYYY-MM-DD') + "T23:59:59.000Z"
        : null,
      agents: this.state.agents,
      product: this.state.product !== 'all' ? this.state.product : null,
      status: this.state.status !== 'all' ? this.state.status : null,
      groupAgent: this.state.groupAgent,
      groupProduct: this.state.groupProduct,
      groupStatus: this.state.groupStatus
    });
  };

  onChange = (currentNode, selectedNodes) => {
    this.setState({ agents: selectedNodes });
  };

  render() {
    return (
      <div className="u-margin-bottom-large" style={{ position: 'relative' }}>
        <div style={{ marginRight: '10px', textAlign: 'right' }}>
          <span
            style={{
              cursor: 'pointer',
              fontWeight: 'bold',
              textDecoration: 'underline',
              fontSize: '14px'
            }}
            onClick={() =>
              this.setState({ showFilters: !this.state.showFilters })
            }
          >
            {this.state.showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}
          </span>
        </div>
        {this.state.showFilters ? (
          <div>
            <div className="form-control u-margin-bottom-small">
              <DateRangePicker
                startDate={this.state.startDate}
                startDateId="startDateId"
                endDate={this.state.endDate}
                endDateId="endDateId"
                onDatesChange={({ startDate, endDate }) =>
                  this.setState({ startDate, endDate })
                }
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                startDatePlaceholderText="Desde"
                endDatePlaceholderText="Hasta"
                showClearDates
                noBorder
                hideKeyboardShortcutsPanel
                minimumNights = {0}
                customArrowIcon={<span className="icon-arrow-right" />}
                isOutsideRange={() => false}
              />
            </div>
            {this.props.agentNetwork.length > 0 && (
              <AgentsTree
                agentNetwork={this.props.agentNetwork}
                onChange={this.onChange}
              />
            )}
            <div className="form-select u-margin-bottom u-margin-right">
              <select
                onChange={evt => {
                  this.setState({ product: evt.target.value });
                }}
              >
                <option value="all">Producto</option>
                <option value="Salud">Salud</option>
              </select>
            </div>
            <div className="form-select u-margin-bottom">
              <select
                onChange={evt => {
                  this.setState({ status: evt.target.value });
                }}
              >
                <option value="all">Estado</option>
                <option value="pending">Pendientes</option>
                <option value="contract">Contratados</option>
              </select>
            </div>
            <div>
              <span style={{ verticalAlign: 'top' }}>Agrupar por</span>
              <div style={{ display: 'inline-block', paddingRight: '110px' }}>
                <label style={{ marginLeft: '15px' }} className="form-check">
                  <input
                    type="checkbox"
                    onChange={evt => {
                      this.setState({ groupAgent: evt.target.checked });
                    }}
                  />
                  <span className="form-check__indicator" />
                  <p>Agente</p>
                </label>
                <label style={{ marginLeft: '15px' }} className="form-check">
                  <input
                    type="checkbox"
                    onChange={evt => {
                      this.setState({ groupProduct: evt.target.checked });
                    }}
                  />
                  <span className="form-check__indicator" />
                  <p>Producto</p>
                </label>
                <label style={{ marginLeft: '15px' }} className="form-check">
                  <input
                    type="checkbox"
                    onChange={evt => {
                      this.setState({ groupStatus: evt.target.checked });
                    }}
                  />
                  <span className="form-check__indicator" />
                  <p>Estado</p>
                </label>
              </div>
            </div>
            <button
              style={{
                float: 'right',
                position: 'absolute',
                bottom: '7px',
                right: '3px', 
                height: '30px'
              }}
              onClick={evt => this.getFiltersData(evt)}
              className="button button--primary"
            >
              Filtrar
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/SentBudgets/Filters.js